import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useContext, useEffect } from "react";

import "./Heart_Component.css";
import { Button, Card } from "react-bootstrap";

import { Context } from "../../../utils/context";

import { useNavigate } from "react-router-dom";
import { addWishlist } from "../../../utils/apis/Wishlist/Wishlist";
import Login_Modal from "../../Common_modal/login_modal/Login_Modal";

function Heart_Component({ product, variant }) {
  const {
    wishlistData,
    signin,
    setShimmerLoader,
    shimmerLoader,
    wishlistContext,
  } = useContext(Context);


  // const [modalLShow, setModalLShow] = useState(false);
  // const [count, setCount] = useState(1);
  // const handleHeartClick = async () => {
  //   // setShimmerLoader(true);
  //   if (signin) {
  //     const res = await addWishlist({
  //       product_id: product?.id,
  //       variant_id: variant?.id,
  //     });
  //     if (res?.success) {
  //       wishlistContext();
  //     }
  //     // setShimmerLoader(false);
  //   } else {
  //     setModalLShow(true);
  //     // setCount((count) => count + 1);
  //   }
  // };

  const handleHeartClick = async () => {
    // setShimmerLoader(true);
    if (signin) {
      const res = await addWishlist({
        product_id: product?.id,
        variant_id: variant?.id,
      });
      if (res?.success) {
        wishlistContext();
      }
      setShimmerLoader(false);
    } else {
      setShimmerLoader(false);
      setModalLShow(true);
      // setCount((count) => count + 1);
      // navigate("/login");
    }
  };

  const [modalLShow, setModalLShow] = useState(false);
  const [count, setCount] = useState(0);


  return (
    <>
      <div className="hearticn" onClick={() => handleHeartClick()}>
        <FontAwesomeIcon
          icon={faHeart}
          className={
            wishlistData?.some(
              (item) =>
                item.product_id === product?.id
            )
              ? "gobiheartss"
              : "gobiheart"
          }
        />

      </div>
      <Login_Modal
        key={count}
        show={modalLShow}
        onHide={() => setModalLShow(false)}
      />
    </>
  );
}

export default Heart_Component;
